module.exports = __webpack_public_path__ + "img/110-Gris Anthracite Structuré.jpg";